import React, { FC } from 'react';
import { FieldProps } from 'formik';
import { Textarea } from '@endpoint/blockparty';

export const FormikTextArea: FC<FieldProps> = ({ field, form, ...props }) => <Textarea {...field} {...props} />;
